// extracted by mini-css-extract-plugin
export default {"contact-info-title":"contact_contact-info-title__ZmsVu","placeholder-style":"contact_placeholder-style__ZIIjl"};